import { createSelector } from '@reduxjs/toolkit';
import { every, filter, get } from 'lodash/fp';
import type { RootState } from 'app/store/reducers';

const selectSlice = (state: RootState) => state.startup;
const selectInitEvents = createSelector(selectSlice, get('initEvents'));

export const selectStartupQueriesDone = createSelector(
    selectInitEvents,
    every((v) => v)
);

export const selectStartupProgress = createSelector(
    selectInitEvents,
    (events) => filter((v) => v, events).length / Object.values(events || {}).length
);

export const selectStartupError = createSelector(selectSlice, get('error'));
